import api from '../../api/api'

// initial state
const state = {
  status: {
    getForm: null
  },
	form: null,
  formData: {}
}

// actions
const actions = {
  getForm ({ commit, state }, params) {
    commit('setStatus', { getForm: api.status.PENDING })
    commit('setForm', null)
    return api.getForm(params).then((response) => {
      commit('setStatus', { getForm: api.status.SUCCESS })
      commit('setForm', response.data)
    }).catch((error) => {
      commit('setStatus', { getForm: api.status.FAILURE })
    })
  },
}

const mutations = {
  setForm (state, form) {
    state.form = form
  },
  setFormData (state, data) {
    state.formData = data
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}


export default {
  namespaced: true,
  state,
  actions,
  mutations
}
